module.exports = __webpack_public_path__ + "static/img/swiper_delte.1dfb0e8e.svg";